export default __webpack_public_path__ + "static/media/icon-right-arrow-dark-gray.4c6b6848.svg";